/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSJpbmhlcml0IiBkPSJNMSA1LjAyOVY0LjI3aDUuMjg2di43NThINC4wN3Y2LjI5aC0uODU0VjUuMDNIMVpNOC42NzcgMnYxMS41OTFINy45OVYyaC42ODhaTTEwLjc3NCAxMS4zMlY0LjI3SDE1di43NThoLTMuMzczVjcuNDFoMy4wNTZ2Ljc1N2gtMy4wNTZ2My4xNTNoLS44NTNaIi8+PC9zdmc+";